<template>
  <header style="padding-top: 20px;background-color: #00A0B2;">
    <nav style="-webkit-box-shadow: none;" class="cor-app-pri-bg" role="navigation">
      <div class="row">
        <div class="col s6 no-padding">
          <a @click="goToHome">
            <img class="logo-header" src="@/assets/img/logo_recad_branca.svg" alt="Logo IPEJUN">
          </a>
        </div>
        <a data-target="mobile-menu" class="right sidenav-trigger"><i class="material-icons">menu</i></a>
        <ul class="col s3 no-padding right hide-on-med-and-down">
          <li>
            <a @click="goToHome" class="logout-button z-depth-0 lighten-4 right no-padding">
              <i class="material-icons">home</i>
              <b>Início</b>
            </a>
          </li>
          <li>
            <a @click="goToPage('/Ajuda/')" class="logout-button z-depth-0 lighten-4 right no-padding">
              <i class="material-icons">help_outline</i>
              <b>Ajuda</b>
            </a>
          </li>
          <li>
            <a @click="goToPage('/Contato/')" class="logout-button z-depth-0 lighten-4 right no-padding">
              <i class="material-icons">chat</i>
              <b>Contato</b>
            </a >
          </li>
          <li>
            <a @click="goToPage('/Legal/')" class="logout-button z-depth-0 lighten-4 right no-padding">
              <i class="material-icons">library_books</i>
              <b>Legal</b>
            </a>
          </li>
          <li>
            <a @click="goToPage('/Privacy/')" class="logout-button z-depth-0 lighten-4 right no-padding">
              <i class="material-icons">lock</i>
              <b>Privacidade</b>
            </a>
          </li>
          <li>
            <a @click="goToPage('/Sobre/')" class="logout-button z-depth-0 lighten-4 right no-padding">
              <i class="material-icons">info</i>
              <b>Sobre</b>
            </a>
          </li>
          <template v-if="no_auth !== true">
          <li>
            <a @click="logOut" class="logout-button z-depth-0 lighten-4 right no-padding">
              <i class="material-icons">exit_to_app</i>
              <b>{{ meta.profile_text.exit }}</b>
            </a>
          </li>
          </template>
        </ul>
      </div>
    </nav>
    <ul v-if="no_auth !== true" class="sidenav" id="mobile-menu">
      <li>
        <a @click="goToHome" class="logout-button z-depth-0 lighten-4 right no-padding">
          <i class="material-icons">home</i>
          <b>Início</b>
        </a>
      </li>
      <li>
        <a @click="goToPage('/Ajuda/')" class="logout-button z-depth-0 lighten-4 right no-padding">
          <i class="material-icons">help_outline</i>
          <b>Ajuda</b>
        </a>
      </li>
      <li>
        <a @click="goToPage('/Contato/')" class="logout-button z-depth-0 lighten-4 right no-padding">
          <i class="material-icons">chat</i>
          <b>Contato</b>
        </a>
      </li>
      <li>
        <a @click="goToPage('/Legal/')" class="logout-button z-depth-0 lighten-4 right no-padding">
          <i class="material-icons">library_books</i>
          <b>Fundamentação legal</b>
        </a>
      </li>
      <li>
        <a @click="goToPage('/Privacy/')" class="logout-button z-depth-0 lighten-4 right no-padding">
          <i class="material-icons">lock</i>
          <b>Privacidade</b>
        </a>
      </li>
      <li>
        <a @click="goToPage('/Sobre/')" class="logout-button z-depth-0 lighten-4 right no-padding">
          <i class="material-icons">info</i>
          <b>Sobre</b>
        </a>
      </li>
      <template v-if="no_auth !== true">
        <li>
          <a @click="logOut" class="logout-button z-depth-0 lighten-4 right no-padding">
            <i class="material-icons">exit_to_app</i>
            <b>{{ meta.profile_text.exit }}</b>
          </a>
        </li>
      </template>
    </ul>
  </header>
</template>
<script>
import axios from 'axios'
import Loading from './Loading.vue'
import {CONFIG} from '@/config/config'
import { formataCPF, verificaTokenUsuario } from '@/assets/js/form-utils.js'
import { validaCPF } from '@/assets/js/script'
import { logOut, closeRightSidebar } from "@/assets/js/scripts-login"
import SocialService from '@/services/social-service.js'

let socialService = new SocialService(CONFIG.URL_SOCIAL_API_V2)

export default {
  name: "Header",
  components: {
    loading: Loading,
  },
  props: {
    no_auth: Boolean
  },
  data() {
    return {
      loading: true,
      pf_id: this.$route.params.pf_id,
      meta: this.$store.state.meta.data,
      logOut: logOut
    }
  },
  methods: {
    initFields() {
      M.Modal.init(document.querySelectorAll('.modal'))
      M.Sidenav.init(document.querySelectorAll('.sidenav'))
    },
    goToHome() {
      if(this.verificaTokenUsuario() === true){
        this.$router.push('/Censo/')
      } else {
        this.$router.push('/')
      }
      M.Sidenav.getInstance(document.querySelector('.sidenav')).close()
    },
    goToPage(page) {
      this.$router.push(page)
      M.Sidenav.getInstance(document.querySelector('.sidenav')).close()
    },
    verificaTokenUsuario(){
      try {
        if (localStorage.token !== '') {
          var splitToken = localStorage.token.split('.')
          if (splitToken.length > 1) {
            var tokenData = JSON.parse(window.atob(splitToken[1]))
            if ('user' in tokenData['data']) {
              // Token de usuário presente no localStorage
              return true
            }
          }
        }
      } catch (e) {
        console.log(`Token inválido/inexistente no localStorage: ${e.toString()}`)
      }
      return false
    }
  },
  mounted() {

    this.$root.$on('loadingHeader', () => {
      this.loading = true
    })

    this.$root.$on('stopLoadingHeader', () => {
      this.loading = false
    })

    this.initFields()
  },
  updated() {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue